import { PayloadAction } from '@reduxjs/toolkit'
import { getBankingProductMovements } from '@repo/accounts-services'
import { BankingProductMovementsParams, MovementFilters } from '@repo/accounts-types'
import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import { put, select } from 'redux-saga/effects'
import { accountsBankingProductMovementsFiltersSelector } from '../../../../selectors'
import {
  bankingProductMovementsDataActions,
  bankingProductMovementsDownloadActions,
} from '../../../../slices'

export const bankingProductMovementsDownloadConfig: Record<string, DownloadServiceConfiguration> = {
  [bankingProductMovementsDownloadActions.downloadRequest.type]: {
    apiClientDomain: 'accounts',
    service: getBankingProductMovements as DownloadServiceConfiguration['service'],
    actionTypeRequest: bankingProductMovementsDownloadActions.downloadRequest.type,
    actionTypeResponse: bankingProductMovementsDownloadActions.downloadResponse.type,
  },
}

export const serviceConfig = defineSagaForService({
  [bankingProductMovementsDataActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getBankingProductMovements,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: bankingProductMovementsDataActions.getResponse.type,
    actionTypeRequest: bankingProductMovementsDataActions.getRequest.type,
  },
  [bankingProductMovementsDataActions.refreshRequest.type]: {
    apiClientDomain: 'accounts',
    service: getBankingProductMovements,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: bankingProductMovementsDataActions.refreshResponse.type,
    actionTypeRequest: bankingProductMovementsDataActions.refreshRequest.type,
  },
})

export function* loadBankingProductMovementsByFilters({
  payload,
}: PayloadAction<BankingProductMovementsParams>) {
  const { id, productType, isRefreshing = false } = payload
  const filters: MovementFilters = yield select(
    accountsBankingProductMovementsFiltersSelector(id),
  ) || null

  const requestAction = isRefreshing
    ? bankingProductMovementsDataActions.refreshRequest
    : bankingProductMovementsDataActions.getRequest
  yield put(requestAction({ id, productType, ...filters }))
}
